import { createReducer, on } from '@ngrx/store';
import { identityCardActions } from '../identity_card.actions';

export interface CiDownloadState {
    links: string[];
}

export const initialState: CiDownloadState = { links: [] };

export const ciDownloadReducer = createReducer(
    initialState,
    on(identityCardActions.downloadSuccess, (state, { payload }) => ({ ...state, links: payload })),
    on(identityCardActions.clearDownload, () => initialState)
);
